import { getLoadDriftWidget } from "../drift";
const loadDrift = (loadDriftParameter) => {
    const disableChatOnPage = loadDriftParameter.disableChatOnPage;
    const driftInstanceIdentifier = loadDriftParameter.driftInstanceIdentifier;
    if (!disableChatOnPage) {
        getLoadDriftWidget(driftInstanceIdentifier)();
    }
};
export { loadDrift };
